// client/src/hooks/useAdminState.js
import React from "react";

export const useAdminState = () => {
  // Form State
  const [formData, setFormData] = React.useState({
    id: "",
    email: "",
    name: "",
    institution: "",
    about: "",
    typeNumeric: "2",
    statNumeric: "1",
    agenda_time: "",
    agenda_topic: "",
    confirmation_code: "",
    registration_type: "",
    need_time: "",
    role: "",
    type: "",
    description: "",
  });

  const [formStates, setFormStates] = React.useState({
    emailState: "",
  });

  // Modal State
  const [modals, setModals] = React.useState({
    addUser: false,
    updateUser: false,
    registrationInfo: false,
    dataRequestsInfo: false,
  });

  // Alert State
  const [alert, setAlert] = React.useState(null);

  // Helper functions
  const updateFormData = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const updateFormState = (field, value) => {
    setFormStates((prev) => ({ ...prev, [field]: value }));
  };

  const openModal = (modalName) => {
    setModals((prev) => ({ ...prev, [modalName]: true }));
  };

  const closeModal = (modalName) => {
    setModals((prev) => ({ ...prev, [modalName]: false }));
  };

  const resetForm = () => {
    setFormData({
      id: "",
      email: "",
      name: "",
      institution: "",
      about: "",
      typeNumeric: "2",
      statNumeric: formData.statNumeric, // Keep current stat selection
      agenda_time: "",
      agenda_topic: "",
      confirmation_code: "",
      registration_type: "",
      need_time: "",
      role: "",
      type: "",
      description: "",
    });
    setFormStates({ emailState: "" });
  };

  return {
    formData,
    formStates,
    modals,
    alert,
    setAlert,
    updateFormData,
    updateFormState,
    openModal,
    closeModal,
    resetForm,
  };
};

